import React from 'react';
import Reflux from 'reflux';
import { Map } from 'immutable';
import Modal from 'shared/components/misc/modal.jsx';
import UIRegions from 'shared/constants/UIRegions';
import { Row, Col, Button } from 'bootstrap';
import {
  WithTooltip,
  Icon,
  ToggleSwitch,
} from '@shoflo-rundown/polymer.legacy';
import Dropdown from 'shared/components/menus/dropDown.jsx';
import FullScreenCuesheetActions from 'flux/actions/cuesheet.fullscreen/FullScreenCuesheetActions';
import ModalActions from 'shared/flux/actions/ModalActions';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';
import ToastActions from 'flux/actions/ToastActions';
import UserSessionStore from 'flux/stores/UserSessionStore';
import EventCrewListStore from 'flux/stores/EventCrewListStore';
import { ViewRelativePaths } from 'shared/constants/CuesheetViews';
import {
  remotePrompterModalDesc1,
  remotePrompterModalDesc2,
} from 'shared/constants/Messages';
import FullScreenCuesheetStore from 'flux/stores/cuesheet.fullscreen/FullScreenCuesheetStore';

export default React.createClass({
  displayName: 'RemoteTeleprompterModal',

  mixins: [
    Reflux.connectFilter(
      FullScreenCuesheetStore,
      'show',
      (state) => state.show,
    ),
    Reflux.connect(UserSessionStore, 'user'),
    Reflux.connect(EventCrewListStore, 'crew'),
  ],

  getInitialState() {
    return {};
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    const { user } = this.state;

    if (!user) return null;

    return (
      <Modal
        name={UIRegions.RemoteTeleprompterModal}
        title="Remote Prompter"
        className="remote-teleprompter-modal"
        closeButton
      >
        <Row>
          <Col md={24}>
            <p>{remotePrompterModalDesc1}</p>
            <p>{remotePrompterModalDesc2}</p>
          </Col>
        </Row>
        <Row>
          <Col md={24}>
            <div className="remote-teleprompter-link-wrapper">
              <div className="remote-teleprompter-link-description">
                Shareable prompter monitor link:
              </div>
              <div className="operator-dropdown-wrapper">
                <Dropdown config={this._getUserSelectorConfig()} />
              </div>
            </div>
            <div className="remote-teleprompter-toggle-wrapper">
              {this._getInputNode()}
              {this._getToggleSwitch()}
              <span>Access</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={24}>{this._getInputNode}</Col>
        </Row>
        <Row>
          <Col md={24}>{this._getRemoteTeleprompterButtons()}</Col>
        </Row>
        <Row>
          <Col md={24}>
            <div className="remote-teleprompter-done-btn-wrapper">
              <Button
                className="remote-teleprompter-done-btn"
                onClick={this._handleOnHide}
              >
                Done
              </Button>
            </div>
          </Col>
        </Row>
      </Modal>
    );
  },

  _getUserSelectorConfig() {
    const { user, operator } = this.state;

    const name = operator
      ? `${operator.get('firstName')} ${operator.get('lastName')}`
      : `${user.get('firstName')} ${user.get('lastName')}`;

    return Map({
      noCaret: false,
      icon: null,
      content: name,
      items: this._getOrderedMapOfItems(),
    });
  },

  _getOrderedMapOfItems() {
    const { crew } = this.state;

    const crewList = crew.get('list');

    return crewList.map((user) => {
      const name = `${user.get('firstName')} ${user.get('lastName')}`;
      return Map({
        type: 'link',
        content: name,
        onClick: () => this._setPreferredOperator(user),
      });
    });
  },

  _setPreferredOperator(user) {
    this.setState({ operator: user });
  },

  _selectText() {
    const input = document.getElementById('urlText');
    input.focus();
    input.setSelectionRange(0, input.value.length);
  },

  _copyToClipBoard() {
    if (this._linkText !== null) {
      this._linkText.focus();
      document.execCommand('copy');
      ToastActions.copied('Link copied to clipboard');
    }
  },

  _getCopyLinkButton() {
    /**
     * Node does not render for Safari. Because Chrome often includes 'Safari' in its user agent,
     * browsers are only excluded if they contain 'Safari' AND don't contain 'Chrome'
     */
    if (
      navigator.userAgent.indexOf('Safari') !== -1 &&
      navigator.userAgent.indexOf('Chrome') === -1
    ) {
      return null;
    }
    return (
      <Button
        onClick={this._copyToClipBoard}
        className="remote-teleprompter-btn"
      >
        <Icon name="copy" />
        Copy link
      </Button>
    );
  },

  _getInputNode() {
    /**
     * Tooltip only renders for Safari. Because Chrome often includes 'Safari' in its user agent,
     * browsers are only included if they contain 'Safari' AND don't contain 'Chrome'
     */
    let inputField = this._getInputField();

    if (
      navigator.userAgent.indexOf('Safari') !== -1 &&
      navigator.userAgent.indexOf('Chrome') === -1
    ) {
      return (
        <WithTooltip
          delay={1000}
          tip={TooltipConstants.ManualCopyLink}
          placement="top"
        >
          {inputField}
        </WithTooltip>
      );
    }

    return inputField;
  },

  _getInputField() {
    return (
      <input
        readOnly
        label="Remote Prompter Url"
        key={this._linkText}
        type="text"
        ref={(ref) => (this._linkText = ref)}
        id="urlText"
        value={this._getRemotePrompterUrl()}
        autoFocus
        onFocus={this._selectText}
        className="remote-teleprompter-url"
      />
    );
  },

  _getRemoteTeleprompterButtons() {
    let copyLinkButton = this._getCopyLinkButton();

    return (
      <div className="remote-teleprompter-btn-wrappers">
        {copyLinkButton}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={this._getRemotePrompterUrl()}
          className="btn btn-default remote-teleprompter-btn"
        >
          <Icon name="external-link" />
          Open in new tab
        </a>
      </div>
    );
  },

  _getRemotePrompterUrl() {
    const params = this.context.router.state.params;
    const { teamId, eventId, showId, rowId, columnId } = params;

    const { user } = this.state;
    const { operator } = this.state;

    const userId = operator ? operator.get('_id') : user.get('_id');
    const query = window.location.search
      .substring(1)
      .concat(`&userId=${userId}`);

    const remotePrompterUrl =
      window.location.origin +
      `/teams/${teamId}/events/${eventId}/shows/${showId}/rows/` +
      `${rowId}/columns/${columnId}/${ViewRelativePaths.RemoteTeleprompter}?${query}`;

    return remotePrompterUrl;
  },

  _getToggleSwitch() {
    const params = this.context.router.state.params;
    const { teamId, eventId, showId } = params;
    const { show } = this.state;

    if (!show) return;

    let disableRemotePrompter = !show.disableRemotePrompter;

    return (
      <div className="remote-teleprompter-modal-switch">
        <ToggleSwitch
          on={disableRemotePrompter}
          onClick={() => {
            FullScreenCuesheetActions.toggleRemotePrompter(
              teamId,
              eventId,
              showId,
              disableRemotePrompter,
            );
          }}
        />
      </div>
    );
  },

  _handleOnHide() {
    ModalActions.hide(UIRegions.RemoteTeleprompterModal);
  },
});
